import {useLayoutEffect} from 'react';
import axios from "axios";
import {URL_API} from "../utils/globalConfig";
import {logError} from "../components/Utils/FormatData";
import {useDispatch} from "react-redux";
import {useAlert} from "react-alert";
import useAuthz from "./useAuthz";

const useMessage = () => {
	const dispatch = useDispatch();
	const alert = useAlert();
	const [authz, user, profil] = useAuthz();

	useLayoutEffect(() => {
		axios({method: 'get', url: URL_API + '/messagerie/nb-messages-non-lus', params: {userId: user.user_id}})
		.then((response) => {
			dispatch({type: 'CHECK_MESSAGES', payload: response.data});
		})
		.catch((error) => {
			logError(alert, error);
		});
	}, []);

	return null;
}

export default useMessage;